'use client';

import { useEffect } from 'react';
import Link from 'next/link';

export default function WebError({ error, reset }) {
	useEffect(() => {
		console.error(error);
	}, [error]);

	return (
		<div className="container contentStateWrap">
			<div className="contentStateCard contentStateCardError">
				<p className="contentStateEyebrow">Erro no servidor</p>
				<h1>Algo saiu do esperado</h1>
				<p className="contentStateDesc">
					Não foi possível concluir esta operação. Tente novamente ou volte à página inicial.
				</p>
				<div className="contentStateActions">
					<button type="button" className="contentStateBtn contentStateBtnPrimary" onClick={() => reset()}>
						Tentar novamente
					</button>
					<Link href="/" className="contentStateBtn contentStateBtnOutline">
						Página inicial
					</Link>
				</div>
			</div>
		</div>
	);
}
